export const PUBLIC_NAV_ITEMS = ['suite', 'crm', 'bundle', 'marketing-plus', 'smart-crm', 'marketing', 'sales', 'service', 'content', 'data', 'commerce'];
const PUBLIC_NAV_ITEMS_SET = new Set(PUBLIC_NAV_ITEMS);
export function isPublicNavItem(s) {
  return PUBLIC_NAV_ITEMS_SET.has(s);
}